import React, { useEffect, useState } from 'react'
import api from '../api'
import { Terminal, PlayCircle, Tag } from 'lucide-react'
import { Card, PageHeader, Input, Button, Badge, Alert, EmptyState } from '../components/ui'

export default function Script() {
  const [scripts, setScripts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => { load() }, [])

  async function load() {
    setLoading(true); setError('')
    try {
      const res = await api.get('/scripts')
      setScripts(res.data)
    } catch (e) {
      setError(e.response?.data?.message || 'Gagal memuat daftar script')
    } finally { setLoading(false) }
  }

  return (
    <div>
      <PageHeader
        title="Script"
        subtitle="Daftar automasi yang bisa dijalankan manual dari sini, atau lewat tombol Sync di halaman Perangkat Pelanggan"
      />

      {error && <Alert type="error">{error}</Alert>}

      {loading ? (
        <Card style={{ padding: 40, textAlign: 'center', color: 'var(--text-faint)' }}>Memuat...</Card>
      ) : scripts.length === 0 ? (
        <Card style={{ padding: 8 }}><EmptyState icon={Terminal} title="Belum ada script terdaftar" /></Card>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {scripts.map(s => <ScriptCard key={s.id} script={s} />)}
        </div>
      )}
    </div>
  )
}

function ScriptCard({ script }) {
  const [username, setUsername] = useState('')
  const [running, setRunning] = useState(false)
  const [result, setResult] = useState(null)

  async function run() {
    if (!username.trim()) return
    setRunning(true); setResult(null)
    try {
      const res = await api.post(`/scripts/${script.id}/run`, { username: username.trim() })
      setResult({ ok: res.data.success !== false, data: res.data })
    } catch (e) {
      setResult({ ok: false, data: { message: e.response?.data?.message || 'Gagal menjalankan script' } })
    } finally { setRunning(false) }
  }

  return (
    <Card style={{ padding: 20 }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 260 }}>
          <h3 style={{ fontSize: 14.5, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <Terminal size={16} color="var(--brand)" />{script.name}
          </h3>
          <p style={{ fontSize: 12.5, color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: 10 }}>{script.description}</p>
          {script.supportedModels?.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {script.supportedModels.map(m => (
                <Badge key={m} tone="neutral"><Tag size={11} style={{ marginRight: 3 }} />{m}</Badge>
              ))}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
          <Input value={username} onChange={e => setUsername(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && run()}
            placeholder="Username PPPoE" style={{ width: 200 }} />
          <Button icon={PlayCircle} loading={running} onClick={run}>Jalankan</Button>
        </div>
      </div>

      {result && (
        <div style={{ marginTop: 14 }}>
          <Alert type={result.ok ? 'success' : 'error'}>
            {result.data.message}
            {result.data.model && <span style={{ opacity: 0.8 }}> &middot; Model: {result.data.model}</span>}
          </Alert>
        </div>
      )}
    </Card>
  )
}
